import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, w100} from "@pg-design/helpers-css";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {useShouldShowPrice} from "../../hooks/use_should_show_price";
import {GTMEventApplicationSourceSection} from "../../lead/types/GTMEvenApplicationSourceSection";
import {getLeadButtonText} from "../../lead/utils/get_lead_button_text";
import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {getOfferDisplayStatus} from "../../offer/utils/get_offer_display_status";
import {IPropertyDetail} from "../types/IPropertyDetail";

interface IProps {
    property: IPropertyDetail;
}

export const PropertyDetailHeaderPriceVariantC = (props: IProps) => {
    const {property} = props;

    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });

    const buttonText = getLeadButtonText({
        isPriceHidden: !shouldShowPrice,
        isProperty: !!property.id,
        propertyPrice: property.price
    });

    const showPrice = shouldShowPrice && !!property.price;
    const source = showPrice || (property.configuration.show_price && !!property.price) ? ApplicationSource.Property : ApplicationSource.PriceInquiry;

    const gtmData = {
        clickText: buttonText,
        source: GTMEventApplicationSourceSection.HEADER_LEAD,
        vendorName: property.offer.vendor.name ?? property.offer.vendor.id.toString(),
        offerName: property.offer.name ?? property.offer.id.toString()
    };

    return (
        <ApplicationModalButton
            source={source}
            sourceSection={ApplicationSourceSection.MODAL}
            vendorId={property.offer.vendor.id}
            offerId={property.offer.id}
            propertyId={property.id}
            forceClose={getOfferDisplayStatus(property.offer) === "limited"}
            render={({openModal}) => (
                <div css={priceButtonWrap}>
                    <Button
                        onClick={() => openModal(gtmData)}
                        variant="filled_primary"
                        css={showPrice || !property.price ? button : w100}
                        dataTestId={buttonText === InquiryButtonTypeName.PRICE ? OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON : undefined}
                    >
                        {buttonText}
                    </Button>
                </div>
            )}
            currency={property?.offer.currency}
        />
    );
};

//  Styles
const priceButtonWrap = css`
    display: flex;
    flex-direction: column;
    row-gap: ${calculateRemSize(1)};
`;

const button = css`
    min-width: 20rem;
`;
import {css} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {calculateRemSize, w100} from "@pg-design/helpers-css";
import {OFFER_TEST_IDS} from "@pg-mono/e2e-test-utils";

import {ApplicationModalButton} from "../../application/components/ApplicationModalButton";
import {ApplicationSource, ApplicationSourceSection} from "../../application/utils/ApplicationSource";
import {useShouldShowPrice} from "../../hooks/use_should_show_price";
import {GTMEventApplicationSourceSection} from "../../lead/types/GTMEvenApplicationSourceSection";
import {getLeadButtonText} from "../../lead/utils/get_lead_button_text";
import {InquiryButtonTypeName} from "../../offer/detail/constants/inquiry_button_type";
import {getOfferDisplayStatus} from "../../offer/utils/get_offer_display_status";
import {IPropertyDetail} from "../types/IPropertyDetail";

interface IProps {
    property: IPropertyDetail;
}

export const PropertyDetailHeaderPriceVariantC = (props: IProps) => {
    const {property} = props;

    const shouldShowPrice = useShouldShowPrice({
        offerPriceVisibility: property.offer.configuration.price_visibility,
        vendorPriceVisibility: property.offer.vendor.configuration.price_visibility,
        vendorId: property.offer.vendor.id
    });

    const buttonText = getLeadButtonText({
        isPriceHidden: !shouldShowPrice,
        isProperty: !!property.id,
        propertyPrice: property.price
    });

    const showPrice = shouldShowPrice && !!property.price;
    const source = showPrice || (property.configuration.show_price && !!property.price) ? ApplicationSource.Property : ApplicationSource.PriceInquiry;

    const gtmData = {
        clickText: buttonText,
        source: GTMEventApplicationSourceSection.HEADER_LEAD,
        vendorName: property.offer.vendor.name ?? property.offer.vendor.id.toString(),
        offerName: property.offer.name ?? property.offer.id.toString()
    };

    return (
        <ApplicationModalButton
            source={source}
            sourceSection={ApplicationSourceSection.MODAL}
            vendorId={property.offer.vendor.id}
            offerId={property.offer.id}
            propertyId={property.id}
            forceClose={getOfferDisplayStatus(property.offer) === "limited"}
            render={({openModal}) => (
                <div css={priceButtonWrap}>
                    <Button
                        onClick={() => openModal(gtmData)}
                        variant="filled_primary"
                        css={showPrice || !property.price ? button : w100}
                        dataTestId={buttonText === InquiryButtonTypeName.PRICE ? OFFER_TEST_IDS.OFFER_VIEW.PRICE_BUTTON : undefined}
                    >
                        {buttonText}
                    </Button>
                </div>
            )}
            currency={property?.offer.currency}
        />
    );
};

//  Styles
const priceButtonWrap = css`
    display: flex;
    flex-direction: column;
    row-gap: ${calculateRemSize(1)};
`;

const button = css`
    min-width: 20rem;
`;
